/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connection: NonNullable<unknown> }} Audit_Details_Private_Model_Connection_Added_DescInputs */



/**
* | output |
* | --- |
* | "The model connection \"{connection}\" was added." |
*
* @param {Audit_Details_Private_Model_Connection_Added_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_private_model_connection_added_desc = /** @type {((inputs: Audit_Details_Private_Model_Connection_Added_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Private_Model_Connection_Added_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Modell-Verbindung "${i?.connection}" wurde hinzugefügt.`)
	return /** @type {LocalizedString} */ (`The model connection "${i?.connection}" was added.`)
});